<template>
  <div class="bill-list">
    <!--标题栏-->
    <app-header title="账单详情" @goback="goBack"></app-header>
    <div class="bill-time">
      <div>账单时间</div>
      <time-range :start-time="startTime" :end-time="endTime" @confirmStart="confirmStart" @confirmEnd="confirmEnd"></time-range>
    </div>
    <div class="bill-list-content">
      <pull-to :is-top-bounce="false" :is-bottom-bounce="isLoadAll" :bottom-load-method="loadmore">
      <ul>
        <li v-for="(item, index) in serviceList" :key="index">
          <div class="list-top">
            <div>{{ item.productName }}</div>
            <div>{{ item.flowType === 'consume' ? `-${item.price}` : `+${item.price}`}}</div>
          </div>
          <div class="list-bottom">
            <!-- <div><span>{{ item.productName }}</span></div> -->
            <div>{{ format(item.createTime) }}</div>
          </div>
        </li>
      </ul>
      </pull-to>
    </div>
  </div>
</template>

<script>
import { commonMixin } from 'common/js/mixin';
import timeRange from 'components/time-range';
import apis from 'api/index';
import { mapGetters } from 'vuex';
import moment from 'moment';
import PullTo from 'vue-pull-to';

export default {
  mixins: [commonMixin],
  components: {
    timeRange,
    PullTo
  },
  data() {
    return {
      servicePageNumber: 1,
      servicePageSize: 10,
      serviceList: [],
      serviceTotal: 0,
      startTime: moment().subtract(1, 'months'),
      endTime: moment(),
    }
  },
  computed: {
    // 用来控制是否启用下拉刷新
    isLoadAll() {
      return Boolean(this.serviceTotal > this.servicePageNumber * this.servicePageSize)
    },
    ...mapGetters(['userAllInfo'])
  },
  created() {
    this.fetchSuccessServiceList();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    confirmStart(date) {
      this.startTime = moment(date);
      this.fetchSuccessServiceList('reset');
    }, 
    confirmEnd(date) {
      this.endTime = moment(date);
      this.fetchSuccessServiceList('reset');
    },
    loadmore(loaded) {
      if(this.serviceTotal <= this.servicePageNumber * this.servicePageSize) {
        return false;
      }
      this.servicePageNumber +=1;
      
      this.fetchSuccessServiceList().then(res => {
        loaded('done');
      });
    },
    goToDetail(id) {
      this.$router.push({ path: `/bill-detail/${id}` });
    },
    format(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss');
    },
    async fetchSuccessServiceList(type = 'default') {
      let params = {};
      params.no = this.servicePageNumber;
      params.limit = this.servicePageSize;
      params.stime= this.startTime.format('YYYY-MM-DD HH:mm:ss');
      params.etime = this.endTime.format('YYYY-MM-DD 23:59:59');
      const res = await apis.getBillList(params);
      if(res) {
        if(type === 'reset') {
          this.serviceList = res.records;
        } else {
          this.serviceList = this.serviceList.concat(res.records);
        }
        this.serviceTotal = res.total;
      }
    },
  }  
}
</script>

<style lang="scss" scoped  src="./bill.scss"></style>

